import WrestlerDetailsHeadingInfo from './DetailsHeadingInfo';
import WrestlerClassEra from './SuperstarClassEra';
import React from 'react';
import { useResponsive } from '@wwe-portal/ui/hooks/use-responsive';
import { cn } from '@wwe-portal/ui/lib/lib';
import Image from 'next/image';
import { SuperstarAvatarProps } from '@wwe-portal/entities/superstar.type';

interface PlayerProfileProps {
  avatarData: SuperstarAvatarProps;
}

const SuperstarAvatar: React.FC<PlayerProfileProps> = ({ avatarData }) => {
  const { isMobile, isHydrated } = useResponsive();
  return (
    <div
      className={cn('top-[100px] box-border w-full', {
        sticky: !isMobile,
      })}
    >
      <div>
        {isMobile && isHydrated ? (
          <WrestlerDetailsHeadingInfo
            name={avatarData.name}
            description={avatarData.description}
          />
        ) : null}
        <div className="bg-back400 relative mb-2.5 rounded-lg p-5">
          <Image
            width={500}
            height={500}
            priority={true}
            src={avatarData.imagePNG}
            alt="profile"
            className="w-full"
          />
          {avatarData?.tier && (
            <div className="absolute bottom-2.5 left-0 right-0 m-auto box-border w-[140px] overflow-hidden">
              <img
                src="/assets/images/tier_tag_part_1.webp"
                alt=""
                className="box-border w-full border-none align-middle"
              />
              <img
                src="/assets/images/tier_tag_part_new.webp"
                alt=""
                className="absolute left-0 right-0 top-0.5 m-auto box-border w-[82%] border-none align-middle"
              />
              <div
                className={cn(
                  'absolute left-0 right-0 top-0.5 m-auto box-border h-[45px] w-[112px] border-l-[22px] border-r-[22px] border-t-[45px] border-transparent',
                  {
                    'border-t-[#c39628]':
                      avatarData.tier === 'S+' || avatarData.tier === 'SPlus',
                    'border-t-[#dc1134]': avatarData.tier === 'S',
                    'border-t-[#417e35]': avatarData.tier === 'B',
                    'border-t-[#b112e8]': avatarData.tier === 'A',
                    'border-t-[#64745f]':
                      avatarData.tier === 'SPlus' || avatarData.tier === 'C',
                  }
                )}
              ></div>
              <p className="absolute inset-0 m-auto mb-0 mt-0 box-border text-center text-sm italic text-white">
                {avatarData.tier} Tier
              </p>
            </div>
          )}
        </div>
        <div className="bg-bgColor15 flex justify-between rounded-lg p-5">
          <WrestlerClassEra
            wClass={avatarData?.class ?? ''}
            wEra={avatarData?.era ?? ''}
            wStable={avatarData?.stable ?? []}
          />
        </div>
      </div>
    </div>
  );
};

export default SuperstarAvatar;
